<template>
  <div class="">
    <Navbar />
    <section class="admin-content">
      <!-- Page Header -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex flex-wrap align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-edit-2" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Edit User</h4>
              <small style="opacity: .8;">Update bio data and coverage information</small>
            </div>
          </div>
        </div>
      </div>
      <section>
        <div class="container mt-n3 pb-5">
          <div class="row">
            <div class="col-lg-10 mx-auto mt-2">
              <div class="card table-card shadow mb-4">
              <div class="form-card-header">
                <div class="section-number">1</div>
                <div>
                  <p class="mb-0 text-white font-weight-bold" style="font-size:.95rem;">Personal Data</p>
                  <small style="color:rgba(255,255,255,.7);">Use this page to update bio-data information</small>
                </div>
              </div>
                <div class="card-body">

                  <div class="form-row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label class="info-label d-block mb-1" for="inputCity">Sector Type: {{ auth_user.sectorType }}</label>
                        <select class="form-control" v-model="auth_user.sectorType">
                          <option value="Formal">Formal Sector</option>
                          <option value="Informal">Informal Sector</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="info-label d-block mb-1" for="inputCity">Select Informal Sector</label>
                        <select class="form-control" v-model="auth_user.sector">
                          <option value="Basic Healthcare Provision Fund">
                            Basic Healthcare Provision Fund
                          </option>
                          <option value="State Equity Program">
                            State Equity Program
                          </option>
                          <option value="Voluntary Contributor">
                            Voluntary Contributor
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="info-label d-block mb-1" for="inputCity">Select Formal Sector</label>
                        <select class="form-control" v-model="auth_user.sector">
                          <option value="State Civil Servant">
                            State Civil Servant
                          </option>
                          <option value="LGA Civil Servant">
                            LGA Civil Servant
                          </option>
                          <option value="Universal Basic Education">
                            Universal Basic Education
                          </option>
                          <!-- <option value="LGA Pensioneers">
                            LGA Pensioneers
                          </option> -->
                          <option value="Oganized Private Sector Plan">
                            Organized Private Sector Plan
                          </option>
                          <option value="Tertiary Institution Contributory Health Insurance Plan (TICHIP)">
                            Tertiary Institution Contributory Health Insurance
                            Plan (TICHIP)
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group col-md-12">
                      <label class="info-label d-block mb-1">Special Needs</label>
                      <select class="form-control" v-model="auth_user.category_of_vulnerable_group">
                        <option value="Pregnant Women">Pregnant Women</option>
                        <option value="Children under 5">
                          Children under 5
                        </option>
                        <option value="Aged">Aged</option>
                        <option value="IDP">IDP</option>
                        <option value="Physically Challenged">
                          Physically Challenged
                        </option>
                        <option value="People with Special Needs">
                          People with Special Needs
                        </option>
                        <option value="Poorest of the Poor">
                          Poorest of the Poor
                        </option>
                      </select>
                    </div>

                    <div class="form-group col-md-6">
                      <label class="info-label d-block mb-1" for="inputEmail6">Surname</label>
                      <input type="text" v-model="auth_user.lastname" class="form-control" placeholder="Last Name" />
                    </div>
                    <div class="form-group col-md-6">
                      <label class="info-label d-block mb-1" for="inputEmail6">First Name</label>
                      <input type="text" v-model="auth_user.firstname" class="form-control" placeholder="First Name" />
                    </div>
                    <div class="form-group col-md-6">
                      <label class="info-label d-block mb-1" for="inputEmail6">Middle Name</label>
                      <input type="text" v-model="auth_user.middlename" class="form-control"
                        placeholder="Middle Name" />
                    </div>
                    <div class="form-group col-md-6">
                      <label class="info-label d-block mb-1" for="inputEmail4">Email</label>
                      <input type="email" class="form-control" id="inputEmail4" placeholder="Email"
                        v-model="autoEmail" />
                    </div>
                    <div class="form-group col-md-6">
                      <label class="info-label d-block mb-1" for="asd">Phone Number</label>
                      <input v-phone type="text" class="form-control" placeholder="Phone Number"
                        v-model="auth_user.phone_number" />
                    </div>
                    <div class="form-group col-md-6" v-if="user.user_role != 0">
                      <label class="info-label d-block mb-1" for="asd">ZAMCHEMA ID</label>
                      <input type="text" class="form-control" id="asd" placeholder="ZAMCHEMA Number"
                        v-model="auth_user.id_card_number" />
                    </div>
                    <div class="form-group col-md-6">
                      <p>
                        <label class="info-label d-block mb-1" for="inputPassword4">Date of Birth
                          <span class="text-danger">*</span></label>
                      </p>
                      <input type="text" class="form-control" placeholder="Date of Birth" v-model="auth_user.dob" />
                    </div>
                    <div class="form-group col-md-6">
                      <label class="info-label d-block mb-1" for="asd">Computer Number</label>
                      <input type="text" class="form-control" placeholder="Computer Number"
                        v-model="auth_user.salary_number" />
                    </div>

                    <div class="form-group col-md-6">
                      <label class="info-label d-block mb-1" for="asd">NIN </label>
                      <input type="text" class="form-control" placeholder="NIN" v-model="auth_user.nimc_number" />
                    </div>
                    <div class="form-group col-md-6">
                      <label class="info-label d-block mb-1" for="inputCity">Gender</label>
                      <select class="form-control" v-model="auth_user.gender">
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </select>
                    </div>
                    <div class="form-group col-md-6">
                      <label class="info-label d-block mb-1">Marital Status </label>
                      <select class="form-control" v-model="auth_user.marital_status">
                        <!-- <option  :value="auth_user.marital_status">{{auth_user.marital_status}}</option> -->
                        <option value="Married">Married</option>
                        <option value="Widow">Widow</option>
                        <option value="Single">Single</option>
                        <option value="Divorced">Seperated</option>
                        <option value="Divorced">Divorced</option>
                      </select>
                    </div>
                    <div class="form-group col-md-12">
                      <label class="info-label d-block mb-1" for="inputCity">Principal Facility for Accessing Care</label>
                      <select class="form-control" v-model="auth_user.provider_id">
                        <option v-for="facility in providers" v-bind:key="facility.id" :value="facility.id">
                          {{ facility.agency_name }}
                        </option>
                      </select>
                    </div>
                    <div class="form-group col-md-12">
                      <label class="info-label d-block mb-1" for="inputCity">Dependents Facility for Accessing Care</label>
                      <select class="form-control" v-model="auth_user.point_of_care">
                        <option v-for="facility in providers" v-bind:key="facility.agency_name"
                          :value="facility.agency_name">
                          {{ facility.agency_name }}
                        </option>
                      </select>
                    </div>
                    <div class="form-group col-md-6">
                      <label class="info-label d-block mb-1" for="inputCity">Blood Group</label>
                      <select class="form-control" v-model="auth_user.blood">
                        <option value="A+">A+</option>
                        <option value="A-">A-</option>
                        <option value="B+">B+</option>
                        <option value="B-">B-</option>
                        <option value="AB+">AB+</option>
                        <option value="AB-">AB-</option>
                        <option value="O+">O+</option>
                        <option value="O-">O-</option>
                      </select>
                    </div>
                    <div class="form-group col-md-6">
                      <label class="info-label d-block mb-1" for="inputCity">LGA</label>
                      <select class="form-control" v-model="auth_user.localgovt" @change="getWards">
                        <option v-for="lga in lga_states" v-bind:key="lga" :value="lga.id">
                          {{ lga.local_name }}
                        </option>
                      </select>
                    </div>
                    <div class="form-group col-md-6">
                      <label class="info-label d-block mb-1" for="inputCity">Ward </label>
                      <select class="form-control" v-model="auth_user.ward">
                        <option v-for="ward in wards" v-bind:key="ward.id" :value="ward.id">
                          {{ ward.ward_name }}
                        </option>
                      </select>
                    </div>

                    <div class="form-group col-md-6">
                      <label class="info-label d-block mb-1" for="inputCity">Select MDA: {{ auth_user.place_of_work }}
                      </label>

                      <!-- <input
                        type="text"
                        class="form-control"
                        id="asd"
                        placeholder="MDA Name"
                        v-model="auth_user.place_of_work"
                      /> -->

                      <select class="form-control" v-model="auth_user.place_of_work">
                        <option v-for="mda in mdas" v-bind:key="mda.place_of_work">
                          {{ mda.name }}
                        </option>
                      </select>
                    </div>
                    <div class="form-group col-md-12" v-if="auth_user.type != 'client'">
                      <label class="info-label d-block mb-1" for="asd">Company Name</label>
                      <input type="text" class="form-control" id="asd" placeholder="Company Name"
                        v-model="auth_user.agency_name" />
                    </div>
                  </div>

                  <div class="form-group" v-if="auth_user.type == 'client'">
                    <label class="info-label d-block mb-1" for="inputAddress">Home Address</label>
                    <input type="text" class="form-control" v-model="auth_user.address1" placeholder="Address" />
                  </div>
                  <div class="form-group" v-if="auth_user.type != 'client'">
                    <label class="info-label d-block mb-1" for="inputAddress2">Office Address</label>
                    <input type="text" class="form-control" placeholder="Office Address"
                      v-model="auth_user.agencyAddress" />
                  </div>
                  <div class="form-group" v-if="auth_user.type != 'client'">
                    <label class="info-label d-block mb-1" for="inputAddress2">Office Website</label>
                    <input type="text" class="form-control" placeholder="http://example.com or https://example.com"
                      v-model="auth_user.agencyWebsite" />
                  </div>

                  <button type="submit" class="btn btn-submit" @click="editUser">
                    Save changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="vld-parent">
          <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
        </div>
      </section>
    </section>
  </div>
</template>
<script>
  // @ is an alias to /src
  // import Settings from '@/components/Settings.vue'
  import Navbar from "@/views/Navbar.vue";
  import Loading from "vue-loading-overlay";
  //import DatePicker from "vue2-datepicker";
  import "vue2-datepicker/index.css";

  export default {
    // name: 'Home',
    components: {
      Navbar,
      Loading,
      //  DatePicker,
    },
    data() {
      return {
        auth_user: "",
        providers: "",
        wards: "",
        user: null,
        mdas: [],
        image: "",
        sector: "",
        lga_states: "",
        isLoading: false,
        fullPage: true,
      };
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));

      this.axios
        .get(`/api/v1/auth/user/zam/${this.$route.params.id}`)
        .then((response) => {
          this.auth_user = response.data.user;
          console.log(response);
          //get ward
        })
        .catch((error) => {
          console.error(error);
        });
    },
    computed: {
      autoEmail() {
        if (this.auth_user.email == null) {
          let autogenemail =
            this.auth_user.phone_number +
            this.$route.params.id +
            "@zamchemauser.com";
          return autogenemail;
        } else {
          return this.auth_user.email;
        }
      },
    },
    methods: {

      getWards() {
        //get ward
        this.axios
          .get(`/api/v1/auth/getwards/${this.auth_user.localgovt}`)
          .then((response) => {
            this.wards = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
        //end of get ward

      },
      getMDAs() {
        this.axios
          .get(`/api/v1/auth/ministries/4`)
          .then((response) => {
            this.mdas = response.data.data;
            console.log(response.data);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getProviders() {
        this.user = JSON.parse(localStorage.getItem("user"));

        this.axios
          .get(`/api/v1/auth/providerAgency/4`)
          .then((response) => {
            this.providers = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getUser() {
        this.axios
          .get(`/api/v1/auth/user/zam/${this.$route.params.id}`)
          .then((response) => {
            this.auth_user = response.data.user;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      fetchLga() {
        this.axios
          .get(`/api/v1/auth/lga/2683`)
          .then((response) => {
            this.lga_states = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      editUser() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.isLoading = true;
        this.axios
          .post(`/api/v1/auth/editProfile/${this.$route.params.id}`, {
            firstname: this.auth_user.firstname,
            lastname: this.auth_user.lastname,
            email: this.autoEmail,
            type: this.auth_user.type,
            state: "2683",
            localgovt: this.auth_user.localgovt,
            ward: this.auth_user.ward,
            dob: this.auth_user.dob,
            salary_number: this.auth_user.salary_number,
            marital_status: this.auth_user.marital_status,
            gender: this.auth_user.gender,
            genotype: this.auth_user.genotype,
            institutional_id: this.auth_user.institutional_id,
            category_of_vulnerable_group:
              this.auth_user.category_of_vulnerable_group,
            id_card_number: this.auth_user.id_card_number,
            point_of_care: this.auth_user.point_of_care,
            provider_id: this.auth_user.provider_id,
            expiry_date: this.auth_user.expiry_date,
            sector: this.auth_user.sector,
            blood: this.auth_user.blood,
            user_image: this.auth_user.user_image,
            place_of_work: this.auth_user.place_of_work,
            middlename: this.auth_user.middlename,
            nimc_number: this.auth_user.nimc_number,
            password: this.auth_user.password,
            phone_number: this.auth_user.phone_number,
            sectorType: this.auth_user.sectorType,
            agency_name: this.auth_user.agency_name,
            address1: this.auth_user.address1,
            agencyAddress: this.auth_user.agencyAddress,
            agencyWebsite: this.auth_user.agencyWebsite,
          })
          .then((response) => {
            console.log(response);
            this.$toasted.info("User updated Successfully!", {
              position: "top-center",
              duration: 3000,
            });
            this.isLoading = false;
          })
          .catch((error) => {
            console.log(error.response);
          });
      },
    },
    created() {
      this.fetchLga();
      this.getProviders();
      this.getMDAs();
    },
  };
</script>